import { events } from '@estee/elc-service-bus';
import { EventRepository } from '~repositories/EventRepository';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';

export interface IAppointmentReviewWidgetFiltersUseCase {
    serviceName: string;
    location: string;
    sortBy: string;
}

export class AppointmentReviewWidgetFiltersUseCase {
    private serviceName: string;
    private location: string;
    private sortBy: string;
    private eventRepository: EventRepository;

    constructor({ serviceName, location, sortBy }: IAppointmentReviewWidgetFiltersUseCase) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.serviceName = serviceName;
        this.location = location;
        this.sortBy = sortBy;
    }

    public async execute() {
        const appointmentReviewWidgetFiltersPayload = {
            event_name: 'OAB reviews',
            event_category: 'oab reviews',
            event_action: 'review widget filters',
            event_label: `${this.serviceName} - ${this.location} - ${this.sortBy}`
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.APPOINTMENT_REVIEW_WIDGET_FILTERS,
            type: 'link',
            payload: appointmentReviewWidgetFiltersPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    }
}
